import FullPageTransparentLoader from "./FullPageTransparentLoader";

export default FullPageTransparentLoader;
